import { useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';
import { Button, Input } from '../components/ui';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/users/login', { email, password });
      localStorage.setItem('jwt', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      setTimeout(() => {
        const role = String(res.data.user.role || '').toLowerCase();
        const isStaff = ['admin', 'owner', 'dueno', 'dueño'].includes(role);
        navigate(isStaff ? '/dashboard' : '/');
        window.location.reload();
      }, 500);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Error de autenticación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-gradient-to-br from-rs-accent/5 via-transparent to-rs-secondary/5 pointer-events-none" />
      <div className="relative w-full max-w-md">
        <div className="bg-rs-surface border border-rs-border rounded-2xl shadow-card p-8 animate-fade-in">
          <div className="text-center mb-8">
            <img src="/logo.png" alt="Reals Store" className="w-24 mx-auto mb-4 drop-shadow-[0_0_18px_rgba(225,6,0,0.45)]" />
            <h2 className="font-display text-3xl tracking-wide text-metallic mb-1">Bienvenido</h2>
            <p className="font-script text-rs-accent text-glow-red text-lg mb-2">Reals Store</p>
            <p className="text-gray-500">Inicia sesión para continuar</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <Input
              type="email"
              placeholder="Correo electrónico"
              value={email}
              onChange={e => setEmail(e.target.value)}
              leftIcon={
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                </svg>
              }
              required
            />
            <Input
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={e => setPassword(e.target.value)}
              leftIcon={
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              }
              required
            />
            {error && (
              <div className="text-red-400 text-sm text-center py-2 px-3 bg-red-500/10 rounded-lg animate-shake">
                {error}
              </div>
            )}
            <Button type="submit" fullWidth loading={loading} size="lg">
              Iniciar sesión
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
